import api from '@/api';

const resource = 'ei/autorizacao-diario';

export default {
  getListaAutorizacao(data) {
    return api.get(`${resource}`, {
      params: data,
    });
  },
  getAutorizacao(id) {
    return api.get(`${resource}/${id}`);
  },
  postAutorizacao(data) {
    return api.post(`${resource}`, data);
  },
  putAutorizacao(data) {
    return api.put(`${resource}/${data.identificadorautorizacaodiarioprof}`, data);
  },
  deleteAutorizacao(id) {
    return api.delete(`${resource}/${id}`);
  }
};